export default __webpack_public_path__ + "static/media/daily-life.a982eba2.svg";